import { ReactNode } from 'react';

import { attachComponentData } from '@backstage/core-plugin-api';

import { PAGE_CONTENT_MAIN_KEY } from './composition';

export type PageContentMainProps = { children: ReactNode };

export const ContentMain = (_props: PageContentMainProps): null => null;

attachComponentData(ContentMain, PAGE_CONTENT_MAIN_KEY, true);
